<template>
  <main>
    <v-dialog v-model="deleteDialog" max-width="420px">
      <DeleteModal
          title="Deletar"
          textMessage="Tem certeza que remover este produto?"
          cancelBtn="Cancelar"
          okbtn="Remover"
          textObservation=""
          icone="mdi-trash-can-outline"
          @close="(deleteDialog = false)"
          @action="removeProduct"
          :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="saveDialog" max-width="420px">
      <DeleteModal
          :title="`${promotion.id ? 'Atualizar Promoção' : 'Cadastrar Promoção'}`"
          :textMessage="`Tem certeza que deseja ${promotion.id ? 'atualizar promoção' : 'cadastrar promoção'}?`"
          cancelBtn="Cancelar"
          :okbtn="`${promotion.id ? 'Atualizar' : 'Cadastrar'}`"
          textObservation=""
          @close="(saveDialog = false)"
          @action="submit"
          :key="dialogKey"
      />
    </v-dialog>

    <Header
        buttonTitle="Criar promoção"
        title="Cadastrar Promoção"
        text="Cadastrar Promoção"
        @voltar="goToRoute('/promotions-center')"
        :haveAction="false"
        :haveBack="true"
    />

    <v-card class="mx-3">
      <v-form ref="promotionForm" v-model="promotionForm" :key="clear">
        <v-row cols="12" sm="12" md="12" lg="12" class="ma-0">
          <v-col cols="12" sm="4" md="4" lg="4">
            <span class="ml-1 mb-2 label-details">Nome</span>
            <v-text-field
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="text"
                hide-details
                placeholder="Digite o nome da promoção"
                v-model="promotion.name"
                :rules="[rules.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <span class="ml-1 mb-2 label-details">Tipo de Beneficio</span>
            <v-select
                :items="status"
                v-model="promotion.discountType"
                hide-details
                height="52"
                style="border: 1px solid #979797; border-radius: 7.5px; width: 100%;!important;"
                background-color="#F5F5F5"
                placeholder="% ou R$"
                item-text="label"
                item-value="value"
                outlined
                required
                @change="setBenefit"
                :rules="[(v) => !!v || 'Item is required']"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <label class="ml-1 mb-2 label-details">Desconto</label>
            <vuetify-money
                color="black"
                v-bind:outlined="outlined"
                background-color="#F5F5F5"
                placeholder="0.0"
                :rules="[rules.required]"
                required
                hide-details
                style="border: 1px solid #979797; border-radius: 7.5px; width: 100%;!important;"
                v-model="promotion.discount"
                v-bind:options="options"
            >
            </vuetify-money>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 label-details">
                Data de inicio da promoção
              </span>

            <v-text-field
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="date"
                hide-details
                v-model="promotion.start"
                :rules="[rules.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 label-details">
                Data de fim da promoção
              </span>

            <v-text-field
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="date"
                hide-details
                v-model="promotion.end"
                :rules="[rules.required]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

      <v-row cols="12" class="mx-3 mt-3" style="z-index: 11;">
        <v-autocomplete
            outlined
            v-model="product"
            :items="products"
            placeholder="Pesquisar produto"
            item-value="productId"
            item-text="productName"
            :loading="loading"
            :search-input.sync="search"
            clearable
            hide-selected
            @change="setProduct()"
        >
        </v-autocomplete>
      </v-row>

    </v-card>

    <v-card class="mx-3">
      <h2 class="text-center py-1">Produtos adicionados</h2>

      <v-row v-if="selectedProducts.length > 0" cols="12" class="px-2">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="list-product-content">
            <div v-for="(item, index) in selectedProducts" class="ma-1" :key="`${item.productId}${index}`">
              <ImageCard
                  :key="item.productId"
                  :item="item"
                  :env_url="env_url"
                  :discountType="promotion.discountType"
                  :discount="promotion.discount"
                  @remove-product="showModalRemoveProduct"
              />
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row v-else cols="12" class="px-2">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <h5 class="text-center py-1">Ainda não há produtos adicionado!</h5>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="mx-3">
      <v-row class="ma-0 mb-5" justify="center">
        <v-col cols="12" sm="6" md="6" lg="6" class="d-flex justify-center">
          <v-btn
              class="cancel-button"
              outlined
              height="50"
              width="100%"
              style="border-radius: 10px"
              @click="back"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" class="d-flex justify-center">
          <v-btn
              width="100%"
              class="primary-button d-flex justify-content-center"
              style="font-weight: bold !important; font-size: 16px !important; height: 50px!important;"
              :loading="loading"
              @click="validate()"
          >
            {{ promotion.id ? "Alterar Promoção" : "Cadastrar Promoção" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

  </main>
</template>

<script lang="js">
import ApiService from '../../../../services/ApiService';
import Header from "./Header";
import ImageCard from "./ImageCard";
import _ from 'underscore'
import moment from 'moment'
import DeleteModal from "../../components/DeleteModal";
import Vue from "vue";

export default {
  name: "PromotionsCenter",
  components: {
    Header,
    ImageCard,
    DeleteModal
  },

  data() {
    return {
      dialogKey: 1,
      deleteDialog: false,
      saveDialog: false,
      productIdRemove: null,
      env_url: "",
      product: "",
      search: "",
      products: [],
      selectedProducts: [],
      loading: false,
      isEditing: false,
      promotionForm: null,
      status: [
        {label: "Percentual", value: 1},
        {label: "Real", value: 2},
      ],
      promotion: {
        id: null,
        name: null,
        discount: 0,
        start: null,
        end: null,
        discountType: 1,
        products: [],
      },
      clear: false,
      apiService: new ApiService(),
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "%",
        suffix: "",
        length: 11,
        precision: 1
      },
      rules: {
        nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
        required: (value) => !!value || "Campo requerido.",
        min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
        postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
      },
      filter: {
        product: "",
        page: 1,
        pageSize: 15,
        selectedSizes: [],
        Subcategories: [],
        orderByPrice: 0,
      },
    }
  },
  created() {
    this.env_url = process.env.VUE_APP_BASE_URL;
  },
  async mounted() {
    this.promotion.id = this.$route.query.id
    if (this.promotion.id) {
      await this.getOnePromotion(this.promotion.id)
    }
  },
  computed: {},
  methods: {
    showModalRemoveProduct(productId) {
      this.deleteDialog = true
      this.productIdRemove = productId
    },

    removeProduct() {
      this.deleteDialog = false
      const productIndex = this.selectedProducts.findIndex((x) => x.productId === this.productIdRemove)
      this.selectedProducts.splice(productIndex, 1)
    },

    async setProduct() {
      try {
        if (this.product) {
          this.loading = true
          let product = this.selectedProducts.find((x) => x.productId === this.product)
          if (!product) {
            product = await this.getOneProduct(this.product)
            this.selectedProducts.push(product)
          }
          this.loading = false
        }
      } catch (e) {

      }
    },

    async getOneProduct(productId) {
      try {
        return await this.apiService.get(`product/get-one?id=${productId}`);
      } catch (e) {

      }
    },

    async getOnePromotion(id) {
      try {
        this.apiService
            .get(`promotion/get-one?id=${id}`)
            .then((response) => {
              this.promotion = response
              this.promotion.start = moment(this.promotion.start).format('YYYY-MM-DD')
              this.promotion.end = moment(this.promotion.end).format('YYYY-MM-DD')
              this.selectedProducts = response.promotionsProduct.map((x) => x.product)
            });
      } catch (e) {

      }
    },

    setBenefit() {
      this.options.prefix = this.promotion.discountType === 1 ? "%" : "R$"
      this.options.precision = this.promotion.discountType === 1 ? 1 : 2
    },

    async back() {
      await this.goToRoute('/promotions-center')
    },

    validate() {
      if (!this.$refs.promotionForm.validate() || moment(new Date(this.promotion.start)).isAfter(new Date(this.promotion.end)) || this.selectedProducts.length <= 0) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Preencha os campos corretamente!",
          trace: null,
        });
        return
      }
      this.saveDialog = true
    },

    async submit() {
      try {
        this.saveDialog = false
        this.promotion.discount = Number(this.promotion.discount);
        this.promotion.products = this.selectedProducts.map((x) => x.productId);
        let method = `post`
        let url = `promotion/add`

        if (this.promotion.id) {
          method = `put`
          url = `promotion/edit`
        }

        this.apiService[method](url, this.promotion)
            .then((response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Promoção cadastrada com sucesso!",
                trace: null,
              });
              this.loading = false;
            })
            .catch((error) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível cadastra promoção, verifique os campos e tente novamente!",
                trace: null,
              });
              this.loading = false;
            });
      } catch (e) {

      }
    },

    async goToRoute(route) {
      if (this.$route.path !== route) {
        await this.$router.push(route);
      }
    },

    async listAllPrducts(query) {
      try {
        this.loading = true
        this.filter.product = query
        const {products} = await this.apiService.post(`product/listActiveB2C`, this.filter, false, false, false)
        this.loading = false
        return products
      } catch (e) {
        this.loading = false
      }
    },


  },

  watch: {
    search: _.debounce(async function (query) {
      if (!query || query.length < 3) return
      this.products = await this.listAllPrducts(query)
    }, 1500),
  }
};
</script>

<style scoped>
.list-product-content {
  /*display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(250px, auto));*/
}


</style>
